import { render, staticRenderFns } from "./ShopTicketDetail.vue?vue&type=template&id=014ed8f5&scoped=true&"
import script from "./ShopTicketDetail.vue?vue&type=script&lang=js&"
export * from "./ShopTicketDetail.vue?vue&type=script&lang=js&"
import style0 from "./ShopTicketDetail.vue?vue&type=style&index=0&id=014ed8f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014ed8f5",
  null
  
)

export default component.exports